import React from "react";
import { Phone, MessageCircle, Send } from "lucide-react";
import { waLink, telLink } from "@/lib/site-config";

const scrollToForm = () => {
  const el = document.getElementById("lead-form");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const MobileStickyCTA = () => {
  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 glass-strong border-t border-[rgba(255,255,255,0.14)]"
      data-testid="mobile-sticky-cta"
    >
      <div className="grid grid-cols-3">
        <a
          href={telLink()}
          className="flex flex-col items-center justify-center py-3 text-[#E5E2D0] hover:text-[#F3F1E8] border-r border-[#556340]"
          data-testid="mobile-sticky-call"
        >
          <Phone size={18} />
          <span className="text-[10px] uppercase tracking-wider mt-1 font-bold">Anrufen</span>
        </a>
        <a
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center py-3 bg-[#25D366] text-white"
          data-testid="mobile-sticky-whatsapp"
        >
          <MessageCircle size={18} />
          <span className="text-[10px] uppercase tracking-wider mt-1 font-bold">WhatsApp</span>
        </a>
        <button
          onClick={scrollToForm}
          className="flex flex-col items-center justify-center py-3 bg-[#E8E5D0] text-[#3A4230]"
          data-testid="mobile-sticky-form"
        >
          <Send size={18} />
          <span className="text-[10px] uppercase tracking-wider mt-1 font-extrabold">Anfrage</span>
        </button>
      </div>
    </div>
  );
};

export default MobileStickyCTA;
